// src/components/Syllabus.jsx
import React from "react";

const syllabusData = [
  {
    title: "Prelims – General Studies (Paper I)",
    meta: "Duration: 2 hours | 200 Marks | Objective (MCQ)",
    details: [
      "Current Events: National & International importance",
      "History of India & Indian National Movement",
      "Indian & World Geography: Physical, Social, Economic Geography of India & the World",
      "Indian Polity & Governance: Constitution, Political System, Panchayati Raj, Public Policy, Rights Issues, etc.",
      "Economic & Social Development: Sustainable Development, Poverty, Inclusion, Demographics, Social Sector Initiatives",
      "Environmental Ecology, Biodiversity & Climate Change (general issues, no subject-specialization required)",
      "General Science",
    ],
  },
  {
    title: "Prelims – CSAT (Paper II)",
    meta: "Duration: 2 hours | 200 Marks | Objective (MCQ) | Qualifying (33%)",
    details: [
      "Comprehension",
      "Interpersonal Skills & Communication",
      "Logical Reasoning & Analytical Ability",
      "Decision-Making & Problem Solving",
      "General Mental Ability",
      "Basic Numeracy (Class X level: numbers, orders of magnitude, ratio, percentage, averages, profit & loss, time & work, time & distance, etc.)",
      "Data Interpretation (Charts, Graphs, Tables, Data Sufficiency – Class X level)",
      "Note 1: Paper-II of the Civil Services (Preliminary) Examination will be a qualifying paper with minimum qualifying marks fixed at 33%.",
      "Note 2: The questions will be of multiple choice, objective type.",
      "Note 3: It is mandatory for the candidate to appear in both the Papers of Civil Services (Preliminary) Examination for the purpose of evaluation. Therefore, a candidate will be disqualified in case he/she does not appear in both the papers of Civil Services (Preliminary) Examination.",
    ],
  },
];

export default function Syllabus() {
  return (
    <section id="preliminary" className="w-full bg-gray-50 py-8 px-6">
      <div className="px-4 sm:px-6 lg:px-20 py-10 bg-gray-50 h-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#7b0000] mb-10">
          UPSC Prelims Syllabus
        </h2>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {syllabusData.map((section, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl shadow-md border border-gray-200 p-6 flex flex-col"
            >
              {/* Section Header */}
              <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-3">
                {section.title}
              </h3>
              <p className="mb-4 text-gray-600 font-medium">{section.meta}</p>

              {/* Content */}
              <ul className="space-y-2 list-disc pl-5 text-gray-700 text-sm sm:text-base leading-relaxed">
                {section.details.map((point, pIdx) => (
                  <li key={pIdx}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
